import React from 'react'
import { Form } from '@ztechapps/webui.form'
import { useFetch, useRecaptcha } from '@ztechapps/common.hook'
import type { FormikHelpers } from 'formik/dist/types'
import { useContext } from './Context'
import { Stack } from 'react-bootstrap'
import type { ChangePasswordFormValues } from './ChangePasswordForm'

export const Layout = () => {
  const { url, userId, resetUsername, resetCode, components, recaptchaSiteKey, withCurrentPasswordForm } = useContext()

  const [fetchNow] = useFetch(url)
  const { getTokenOrThrow } = useRecaptcha({ recaptchaSiteKey })

  const formSubmit = async (
    { password, confirmPassword, currentPassword }: ChangePasswordFormValues,
    _formikHelpers: FormikHelpers<ChangePasswordFormValues>
  ) => {
    const recaptchaToken = await getTokenOrThrow()

    const data = withCurrentPasswordForm
      ? { _id: userId, currentPassword, newPassword: password, confirmPassword, recaptchaToken }
      : { username: resetUsername, code: resetCode, newPassword: password, confirmPassword, recaptchaToken }

    const { error } = await fetchNow(data)
    if (error) {
      throw error
    }
  }

  const validate = (values: ChangePasswordFormValues) => {
    const error = {} as ChangePasswordFormValues

    if (withCurrentPasswordForm && !values.currentPassword) {
      error.currentPassword = 'Required'
    }

    if (values.password !== values.confirmPassword) {
      error.confirmPassword = 'Passwords do not match.'
    }

    if ((values.password?.length ?? 0) < 6) {
      error.password = 'Password must be at least 6 characters.'
    }

    return error
  }

  return (
    <Form<ChangePasswordFormValues>
      initialValues={{ password: '', confirmPassword: '', currentPassword: '' }}
      onSubmit={formSubmit}
      validate={validate}
    >
      <components.form />
      <components.successAlert />
      <Stack gap={2} className="d-grid">
        <components.button />
        <components.cancelButton />
      </Stack>
    </Form>
  )
}
